._optionSelector__item_180wh_1:not(:last-child) {
  padding-bottom: 12px; }
